import { connect } from '~/store';
import { Location } from '~/helpers/types/Location';

/** Store helper: provides the current user's location. */
export default (component: any): (props: any) => any => (
  connect(({ userLocation }: { userLocation: Location }) => ({ userLocation }))(component)
);
